/*
 * card-product-swiper.js
 *
 * Convierte las imagenes de las tarjetas de producto en la PLP (Product Listing
 * Page) en carruseles deslizables con Swiper solo en mobile.
 *
 * Comportamiento:
 *  - En mobile, al deslizar la imagen funciona como carrusel.
 *  - En desktop se conserva el comportamiento del tema: primera imagen y
 *    segunda imagen al hacer hover.
 *  - Al hacer click/tap sobre la imagen se redirige a la PDP del producto.
 *
 * Swiper, por defecto, activa `preventClicks` y `preventClicksPropagation`,
 * por lo que el click sobre el enlace del slide se cancela automaticamente
 * cuando el gesto ha sido un desplazamiento, evitando una navegacion accidental.
 */
(function () {
  'use strict';

  var SELECTOR = '.plp-media-swiper';
  var MOBILE_QUERY = '(max-width: 749px)';
  var mobileMediaQuery = window.matchMedia(MOBILE_QUERY);
  var swiperInstances = new WeakMap();

  function setCarouselInteraction(el, enabled) {
    // El overlay `.product-redirect-link` y el titulo cubren la imagen en el
    // comportamiento original de desktop. Solo los apartamos mientras Swiper
    // esta activo en mobile.
    var inner = el.closest('.card__inner');
    if (inner) {
      var overlay = inner.querySelector('.product-redirect-link');
      if (overlay) {
        overlay.style.pointerEvents = enabled ? 'none' : '';
      }
    }

    var media = el.closest('.card__media');
    if (media) {
      media.style.zIndex = enabled ? '2' : '';
    }
  }

  function initSwiper(el) {
    if (!el || !mobileMediaQuery.matches || swiperInstances.has(el)) return;

    var slides = el.querySelectorAll('.swiper-slide');
    if (!slides || slides.length < 1) {
      el.dataset.plpSwiperInit = '1';
      return;
    }

    if (typeof Swiper === 'undefined') {
      // Swiper aun no esta disponible; reintentamos mas tarde.
      return;
    }

    el.dataset.plpSwiperInit = '1';

    setCarouselInteraction(el, true);

    var isCollectionPlp =
      document.body.classList.contains('template-collection') &&
      el.closest('#product-grid');
    var scrollbar = isCollectionPlp
      ? el.querySelector('.plp-media-swiper__scrollbar')
      : null;
    var prevEl = el.querySelector('.plp-media-swiper__button--prev');
    var nextEl = el.querySelector('.plp-media-swiper__button--next');

    try {
      var instance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        // Solo activamos loop y grabCursor si hay mas de una imagen
        loop: slides.length > 1,
        grabCursor: slides.length > 1,
        // Umbral para distinguir un tap de un desplazamiento.
        threshold: 5,
        // Evita que un click se dispare tras un swipe (valores por defecto,
        // los declaramos explicitamente para mayor claridad).
        preventClicks: true,
        preventClicksPropagation: true,
        watchOverflow: true,
        a11y: { enabled: true },
        scrollbar: scrollbar
          ? {
              el: scrollbar,
              enabled: true,
              hide: false,
              draggable: false,
              dragSize: 'auto',
            }
          : false,
        // La navegacion por flechas solo si hay mas de una imagen
        navigation: (prevEl && nextEl && slides.length > 1)
          ? { prevEl: prevEl, nextEl: nextEl }
          : false,
      });
      swiperInstances.set(el, instance);
    } catch (err) {
      // Si falla la inicializacion dejamos el markup como fallback (imagenes
      // apiladas dentro de enlaces a la PDP).
      el.dataset.plpSwiperInit = '0';
      if (window.console && console.error) {
        console.error('[card-product-swiper] No se pudo inicializar Swiper', err);
      }
      setCarouselInteraction(el, false);
    }
  }

  function destroySwiper(el) {
    if (!el) return;

    var instance = swiperInstances.get(el);
    if (instance && typeof instance.destroy === 'function' && !instance.destroyed) {
      instance.destroy(true, true);
    }

    swiperInstances.delete(el);
    el.dataset.plpSwiperInit = '0';
    setCarouselInteraction(el, false);
  }

  function syncSwiper(el) {
    if (mobileMediaQuery.matches) {
      initSwiper(el);
    } else {
      destroySwiper(el);
    }
  }

  function syncAll() {
    document.querySelectorAll(SELECTOR).forEach(syncSwiper);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    syncAll();

    // Activa o desmonta Swiper al cruzar el breakpoint mobile/desktop.
    if (mobileMediaQuery.addEventListener) {
      mobileMediaQuery.addEventListener('change', syncAll);
    } else if (mobileMediaQuery.addListener) {
      mobileMediaQuery.addListener(syncAll);
    }

    // Las colecciones cargan/filtran productos de forma dinamica (paginacion
    // AJAX, facetas, etc.). Observamos el DOM para inicializar las tarjetas
    // que aparezcan posteriormente.
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (!(node instanceof HTMLElement)) continue;
            if (node.matches && node.matches(SELECTOR)) {
              syncSwiper(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll(SELECTOR).forEach(syncSwiper);
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });
})();
